import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-changeEnter",
  "use": "icon-changeEnter-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-changeEnter\"><defs><style type=\"text/css\"></style></defs><path d=\"M864 464H160c-17.6 0-32-14.4-32-32s14.4-32 32-32h639.04l-120.32-156.48c-10.72-14.08-8.16-34.08 5.92-44.8s34.08-8.16 44.8 5.92l160 208c7.36 9.6 8.8 22.72 3.36 33.6-5.44 10.88-16.64 17.76-28.8 17.76zM320 832c-9.6 0-19.04-4.32-25.44-12.48l-160-208c-7.36-9.6-8.8-22.72-3.36-33.6A32.16 32.16 0 0 1 159.84 560h704c17.6 0 32 14.4 32 32s-14.4 32-32 32H224.8l120.32 156.48c10.72 14.08 8.16 34.08-5.92 44.8-5.44 4.64-12.32 6.72-19.2 6.72z\" p-id=\"2323\" fill=\"#d81e06\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/changeEnter.svg
// module id = NjUi
// module chunks = 197